import Button from '@/components/Buttons/Button';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { PromptContainer } from './common';
import success from './images/success.svg';

const MainContainer = styled.div``;

const GreyContainer = styled(PromptContainer)`
    height: 160px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    margin-top: 65px;
`;

const DoneButton = styled(Button)`
    margin: 32px auto 0 auto;
    font-size: 18px;
    padding: 24px;
`;

interface Props {
    onClose: () => void;
}

function SuccessDialogContent({ onClose }: Props) {
    return (
        <MainContainer>
            <GreyContainer>
                <img src={success} />
                <Typography variant="body1" fontWeight={600} letterSpacing={0.17}>
                    Your voice has been created!
                </Typography>
            </GreyContainer>
            <DoneButton onClick={onClose}>Done</DoneButton>
        </MainContainer>
    );
}

export default SuccessDialogContent;
